import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ToastrService } from 'ngx-toastr';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

import { ConfirmComponent } from '../../modals';
import { TaskNotesComponent } from '../../modals';
import { MeetingsService } from '../../services';
import { TasksService } from '../../services';

export interface TaskPerformersModel {
    title: string;
    button: string;
    label: string;
    performers: Array<any>;
    edit: boolean;
    task_id: number;

    meeting: boolean;
    dates: any;
}

@Component({
    selector: 'task-performers',
    templateUrl: './task-performers.html',
    styleUrls: ['./task-performers.scss']
})

export class TaskPerformersComponent extends DialogComponent<TaskPerformersModel, any> implements TaskPerformersModel, OnInit {
    title: string;
    button: string;
    label: string;
    performers: Array<any>;
    edit: boolean;
    task_id: number;

    meeting: boolean;
    dates: any;

    data = [];
    filterQuery = '';
    rowsOnPage = 10;
    sortBy = 'name';
    sortOrder = 'asc';

    private searchForm: FormGroup;
    private search: AbstractControl;
    private performers_control: AbstractControl;

    private filter_term: string;

    private performers_arr = [];
    private dropdownSettings: IMultiSelectSettings = {
        enableSearch: false,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 10,
        fixedTitle: true,
        closeOnClickOutside: false,
        selectionLimit: 1,
        autoUnselect: true,
        containerClasses: 'dropdown-members'
    };

    private users_text: IMultiSelectTexts = {
        searchPlaceholder: 'Pronađi člana',
        searchEmptyResult: 'Nije pronađen niti jedan član...',
        defaultTitle: 'Dodaj člana...',
    };

    private status = [
        'Nije odgovorio/la',
        'Prihvaćen',
        'Odbijen'
    ]

    private search_error_msg: boolean = false;
    private errorMsg: string = '';

    constructor(
        dialogService: DialogService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private slimLoader: SlimLoadingBarService,
        private meetingsService: MeetingsService,
        private tasksService: TasksService
    ) {
        super(dialogService);
    }

    // For datatables
    toInt(num: string) {
        return +num;
    }

    ngOnInit() {

        this.searchForm = this.formBuilder.group({
            search: [''],
            performers_control: []
        });

        this.search = this.searchForm.controls['search'];

        this.searchForm.controls['performers_control'].valueChanges.subscribe((value) => {
            if (value !== null) {
                if (value.length > 0) {
                    for (let i = 0; i < value.length; i++) {
                        this.addUser(value[i]);
                    }
                }
            }
        });

        if (this.performers.length > 0) {
            for (let i = 0; i < this.performers.length; i++) {
                if (this.performers[i].task_accepted) {
                    this.performers[i].task_status = this.status[this.performers[i].task_accepted - 1];
                } else {
                    this.performers[i].task_status = this.status[this.performers[i].status];
                }
                if (this.performers[i].performer_id) {
                    this.performers[i].id = this.performers[i].performer_id;
                }
                this.data.push(this.performers[i]);
            }
        }
    }

    // Add user function
    addUser(value) {
        this.searchForm.controls.performers_control.reset();
        let found = this.data.some(function (el) {
            return el.id === value;
        });
        if (!found) {
            for (let i = 0; i < this.performers_arr.length; i++) {
                if (this.performers_arr[i].id === value) {
                    let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                        title: 'Dodaj člana',
                        message: 'Jeste li sigurni da želite dodati ' + this.performers_arr[i].first_name + ' ' + this.performers_arr[i].last_name + ' ?',
                        button: 'Dodaj',
                    })
                        .subscribe((isConfirmed) => {
                            if (isConfirmed) {
                                if (this.meeting) {
                                    this.meetingsService.getUserAvailability(value, this.dates).subscribe(
                                        response => {
                                            //Add user to datatable
                                            this.data.push(this.performers_arr[i]);
                                            this.toastr.success("Uspješno ste dodali člana");
                                        },
                                        error => {
                                            let activeModal = this.dialogService.addDialog(ConfirmComponent, {
                                                title: 'Član/ica već ima ugovoren sastanak',
                                                message: 'Član/ica u navedeno vrijeme već ima ugovoren drugi sastanak.',
                                                button: 'Svejedno dodaj',
                                            })
                                                .subscribe((isConfirmed) => {
                                                    if (isConfirmed) {
                                                        //Add user to datatable
                                                        this.data.push(this.performers_arr[i]);
                                                        this.toastr.success("Uspješno ste dodali člana");
                                                    }
                                                });
                                        },
                                    );
                                } else {
                                    //Add user to datatable
                                    this.data.push(this.performers_arr[i]);
                                    this.toastr.success("Uspješno ste dodali člana");
                                }
                            }
                        });
                }
            }
        } else {
            this.toastr.error("Korisnik je već dodan kao član!");
        }
    }

    //Search users function
    searchUsers(term) {
        this.filter_term = term;

        this.meetingsService.getMeetingMembers(this.filter_term).subscribe(
            response => {
                if (response.users.length > 0) {
                    this.search_error_msg = false;
                    for (let i = 0; i < response.users.length; i++) {
                        if (response.users[i].first_name) {
                            response.users[i].name = response.users[i].first_name + ' ' + response.users[i].last_name + ' - ' + response.users[i].email;
                        } else {
                            response.users[i].name = response.users[i].email;
                        }
                    }
                } else {
                    this.search_error_msg = true;
                }
                this.performers_arr = response.users;
                this.slimLoader.complete();
            },
            error => {
                if (error.error_msg) {
                    this.toastr.error(error.error_msg);
                    this.errorMsg = error.error_msg;
                    this.slimLoader.complete();
                }
            },
        );
    }

    //Task completed function
    onTaskCompleted() {
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title: 'Završi zaduženje',
            message: 'Jeste li sigurni da želite završiti zaduženje?',
            button: 'Završi',
        })
            .subscribe((isConfirmed) => {
                if (isConfirmed) {
                    this.tasksService.taskCompleted(this.task_id).subscribe(
                        response => {
                            this.slimLoader.complete();
                            this.toastr.success(response.message);
                        },
                        error => {
                            if (error.error_msg) {
                                this.toastr.error(error.error_msg);
                            }
                        },
                    );
                }
            });
    }

    userNotes(note) {
        if (note !== null) {
            let activeModal = this.dialogService.addDialog(TaskNotesComponent, {
                title: 'Bilješke',
                note: note,
            })
                .subscribe((isConfirmed) => {

                });
        } else {
            let activeModal = this.dialogService.addDialog(TaskNotesComponent, {
                title: 'Bilješke',
                note: 'Korisnik trenutno nema bilješki.',
            })
                .subscribe((isConfirmed) => {

                });
        }
    }


    //Delete user from datatable
    onDeleteUser(user) {
        let activeModal = this.dialogService.addDialog(ConfirmComponent, {
            title: 'Izbriši člana',
            message: 'Jeste li sigurni da želite izbrisati ' + user.first_name + ' ' + user.last_name + ' ?',
            button: 'Izbriši',
        })
            .subscribe((isConfirmed) => {
                if (isConfirmed) {
                    if (user.id) {
                        let id = user.id;
                        const toDelete = new Set([id]);

                        //Remove user from datatable
                        this.data = this.data.filter(obj => !toDelete.has(obj.id));
                        this.toastr.success("Uspješno ste izbrisali člana");
                        this.searchForm.controls.performers_control.reset();
                    } else {
                        let id = user.performer_id;
                        const toDelete = new Set([id]);

                        //Remove user from datatable
                        this.data = this.data.filter(obj => !toDelete.has(obj.performer_id));
                        this.toastr.success("Uspješno ste izbrisali člana");
                        this.searchForm.controls.performers_control.reset();
                    }
                }
            });
    }

    confirm(data) {
        // we set dialog result as true on click on confirm button, 
        // then we can get dialog result from caller code
        this.result = data;
        this.close();
    }
}


// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/modals/task-performers/task-performers.component.ts